import React from 'react';
import PropTypes from 'prop-types';
import HomeDraftsListSection from './HomeDraftsListSection';
import { getBondCacheResumePath } from '../../../globals/utils/homeHelpers';

/** Draft bond rows (resume / delete) driven by PG home variant config. */
export default function PgHomeDraftsSection({
  draftsCopy,
  sortedCachedBonds,
  cachedBondCount,
  loadingDrafts,
  deletingId,
  onResume,
  onDelete,
}) {
  return (
    <HomeDraftsListSection
      copy={draftsCopy}
      drafts={sortedCachedBonds}
      draftCount={cachedBondCount}
      loadingDrafts={loadingDrafts}
      deletingId={deletingId}
      resolveResumePath={(row) => getBondCacheResumePath(row?.bond_type, row?.bond_cache_id)}
      onResume={onResume}
      onDelete={onDelete}
    />
  );
}

PgHomeDraftsSection.propTypes = {
  draftsCopy: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    emptyDrafts: PropTypes.string,
    resume: PropTypes.string,
    delete: PropTypes.string,
  }).isRequired,
  sortedCachedBonds: PropTypes.array.isRequired,
  cachedBondCount: PropTypes.number.isRequired,
  loadingDrafts: PropTypes.bool.isRequired,
  deletingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onResume: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
